import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { WeightUnity } from '../types/weight-unity.type';
import { UpdateWeightUnityRequestDTO } from '../types/dtos/update-weight-unity.dto';
import { ADMIN_WEIGHT_UNITIES_API_PATHS } from '../constants/weight-unities-api-paths.constants';

type UseUpdateWeightUnityResult = {
  updateWeightUnity: (
    weightUnityId: string,
    weightUnityData: UpdateWeightUnityRequestDTO
  ) => Promise<WeightUnity | null>;
  isSubmitting: boolean;
};

export function useUpdateWeightUnity(): UseUpdateWeightUnityResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const updateWeightUnity = async (
    weightUnityId: string,
    weightUnityData: UpdateWeightUnityRequestDTO
  ): Promise<WeightUnity | null> => {
    setIsSubmitting(true);

    try {
      const updatedWeightUnity = await HttpClient.patch<WeightUnity, UpdateWeightUnityRequestDTO>(
        ADMIN_WEIGHT_UNITIES_API_PATHS.UPDATE_WEIGHT_UNITY(weightUnityId),
        weightUnityData
      );

      enqueueSnackbar("L'unité de poids a été modifiée", { variant: 'success' });
      return updatedWeightUnity;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, "Une erreur est survenue lors de la modification de l'unité de poids"),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { updateWeightUnity, isSubmitting };
}
